<div class="input-group mr-2" *ngIf="props.fieldType === 'datetimepicker'">
  <input
    type="text"
    placeholder="{{ props.label }}"
    class="form-control"
    id="{{ props.field_Name }}"
    formControlName="{{ props.field_Name }}"
    (blur)="inputBlur($event)"
    [value]="dateString | date : props.propFormat"
    (ngModelChange)="onInputChange($event)"
    [disabled]="disabled"
    readonly
  />
  <div class="input-group-append">
    <button
      class="btn btn-outline-secondary"
      [ngbPopover]="calendarContent"
      [disabled]="disabled"
      type="button"
    >
      <img
        src="assets/images/SuperAdmin/calendar.svg"
        style="height: 20px; width: 20px"
        alt="calendar"
      />
    </button>
  </div>
</div>
<sm-error [control]="formcontrol" [label]="props.label"></sm-error>


  <!-- Ngb-datepicker and Ngb-timepicker popover content -->
  <ng-template #calendarContent>
    <div>
      <div *ngIf="!showTimePickerToggle">
        <ngb-datepicker
          id="dp"
          #dp
          [ngModel]="datetime"
          name="datepicker"
          [minDate]="minDate"
          (ngModelChange)="onDateChange($event, dp)"
        ></ngb-datepicker>
        <button
          class="btn btn-block btn-outline-secondary"
          [disabled]="!datetime?.day"
          type="button"
          (click)="toggleDateTimeState($event)"
        >
          <img
            src="assets/images/SuperAdmin/clock.svg"
            style="height: 20px; width: 20px"
            alt="clock"
          />
        </button>
      </div>
      <div *ngIf="showTimePickerToggle">
        <button
          class="btn btn-block btn-outline-secondary"
          type="button"
          (click)="toggleDateTimeState($event)"
        >
          <img
            src="assets/images/SuperAdmin/calendar.svg"
            style="height: 20px; width: 20px"
            alt="calendar"
          />
        </button>
        <div class="mt-auto">
          <ngb-timepicker
            #tp
            name="timepicker"
            [ngModel]="datetime"
            (ngModelChange)="onTimeChange($event)"
            [hourStep]="hourStep"
            [minuteStep]="minuteStep"
            [meridian]="meridian"
          >
          </ngb-timepicker>
        </div>
      </div>
    </div>
  </ng-template>